import { create } from "zustand";
import { ListingDto } from "../types/listings/listing.dto";
import { mapListingDto } from "../types/listings/listing.mapper";
import {
  ListingPaginationData,
  ListingState,
  ListingRequest,
} from "../types/listings/listing.model";

export const useListingStore = create<ListingState>((set) => ({
  loading: false,
  errorMessage: "",
  properties: [],
  hasMore: false,
  offset: 20,
  page: 1,
  totalPages: 1,
  total: 1,
  property: {
    id: 0,
    title: "",
    description: "",
    region: "",
    type: "",
    area: "", // было number
    price: "", // было number
    rooms_count: "", // rooms
    image: "",
    images: [],
    location: {
      // lat: number,
      // lng: number,
      address: "", // address
    },
    seller: {
      name: "",
      phone: "", // phone_number
      email: "", // email
    },
    district: "",
    is_top: false,
    is_vip: false,
    is_urgent: false,
    isFeatured: false,
    isPaid: false,
    createdAt: "",
    // is_like?: boolean, __
    // is_premium?: boolean, __
    moderation_status: "", //?  "PENDING" __
    screeningsTotal: 0,
    updatedAt: "",
    views: 0,
    category: "",
    isLike: false,
    currency: "",
    video_link: ""
  },
  listingRequest: {
    region: "",
    type: "",
    area: "",
    price: "",
    room_count: "",
    image: "",
    images: [],
    title: "",
    description: "",
    address: "",
    phone_number: "",
    email: "",
    is_top: false,
    is_vip: false,
    is_urgent: false,
    isFeatured: false,
    isPaid: false,
    district: "",
    certificate: "",
    video_link: "",
    currency: "",
  },
  setListingRequest: (listingRequest: ListingRequest) => {
    set((prev) => ({
      ...prev,
      listingRequest,
    }));
  },
  setListingData: (paginationData: ListingPaginationData) => {
    set((prev) => ({
      ...prev,
      properties: paginationData.list.map((listing) => mapListingDto(listing)),
      total: paginationData.total,
      ...paginationData.meta,
    }));
  },
  setProperty: (propertyData: ListingDto) => {
    set((prev) => ({
      ...prev,
      property: mapListingDto(propertyData),
    }));
  },
}));

// address: "Мкр. жөн эле";
// area: "921";
// category: "houses"; // type: "house";
// description: "Бул турак жай жөнүндө толук маалымат";
//? district: "aravan";
// email: "email@gmail.com";
//? isFeatured: false;
//? isPaid: false;
// phone: "+996 555 555 555"; // phone_number: "+996 555 555 555";
// price: "12";
// region: "osh";
// rooms: "3"; // room_count: "3";
// title: "3 бөлмөлүү үй";
